import { render, staticRenderFns } from "./SystemVersionList.vue?vue&type=template&id=16b18652&"
import script from "./SystemVersionList.vue?vue&type=script&lang=js&"
export * from "./SystemVersionList.vue?vue&type=script&lang=js&"
import style0 from "./SystemVersionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports